<!-- 关于我們 -->
<template>
    <div>
      <!-- <div class="header_img"></div> -->
       <sub-banner id="id_about">
        <img src="../../assets/images/aboutUs/company_int.jpg"/>
      </sub-banner>
      <div class="company_introduction" v-if="active_menus=='instruction'">
        <div class="company_introd_info">
          <div class="company_introd_detail">
            <div class="title">{{$t('NavabarText.navbr_child_about_1')}}</div>
            <div class="detail_content">
              <div class="item_c">
                <div class="item_c_img">
                  <img src="../../assets/images/aboutUs/about_two.png"/>
                </div>
              </div>
              <div class="item_c">
                <div class="item_c_text">
                  <div class="t_title">{{$t('NavabarText.company_introduct')}}</div>
                  <div class="t_content">{{$t('About_Navbar.introduct')}}
                  </div>
                </div>
              </div>
            </div>
             <div class="detail_content">
              <div class="item_c">
                <div class="item_c_text">
                  <div class="t_title">{{$t('NavabarText.company_team')}}</div>
                  <div class="t_content">{{$t('About_Navbar.team_desc')}}
                  </div>
                </div>
              </div>
              <div class="item_c">
                <div class="item_c_img">
                  <img src="../../assets/images/aboutUs/about_us_old.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="culture_info" v-if="active_menus=='instruction' &&evnPersonItemList.length>0">
        <div class="culture_content">
            <div class="title_s">{{$t('NavabarText.company_person')}}</div>
            <div class="title_descript">{{$t('About_Navbar.eve_person')}}</div>
            <div class="title_descript">{{$t('About_Navbar.eve_person_1')}}</div>
            
            <div class="culture_team">
                <div class="team_content">
                    <div class="env_item" v-for="(item,index) in evnPersonItemList" :key="item.id" :class="item.hidden==true?'team_item_hidden':''">
                        <div class="env_item_img">
                            <el-image :src="item.synopsisImg" :preview-src-list="evnPersonItemListPreview"  :fit="fill" style="height:100%;width:100%"></el-image>
                        </div>
                       
                    </div>
                </div>
                <div class="arrow_left" id="left" @click="leftPersonEnvClick">
                   <span class="icon iconfont icon-zuojiantou1"></span>
                </div>
                <div class="arrow_right" id="right" @click="righPersontEnvClick">
                   <span class="icon iconfont icon-iconfontjiantouyou"></span>
                </div>
            </div>
        </div>
        
    </div>

      <div class="culture_info_back" v-if="active_menus=='instruction' &&evnItemList.length>0">
        <div class="culture_content">
            <div class="title_s">{{$t('NavabarText.company_env')}}</div>
            <div class="title_descript">{{$t('About_Navbar.eve')}}</div>
            <div class="culture_team">
                <div class="team_content">
                    <div class="env_item" v-for="(item,index) in evnItemList" :key="item.id" :class="item.hidden==true?'team_item_hidden':''">
                        <div class="env_item_img">
                            <el-image :src="item.synopsisImg" :preview-src-list="evnItemListPreview" :fit="fill" style="height:100%;width:100%"></el-image>
                        </div>
                       
                    </div>
                </div>
                <div class="arrow_left" id="left" @click="leftEnvClick">
                   <span class="icon iconfont icon-zuojiantou1"></span>
                </div>
                <div class="arrow_right" id="right" @click="rightEnvClick">
                   <span class="icon iconfont icon-iconfontjiantouyou"></span>
                </div>
            </div>
        </div>
        
    </div>
      <!-- <div class="company_environment" v-if="active_menus=='instruction'">
        <div class="company_environment_content">
          <div class="title">{{$t('NavabarText.company_env')}}</div>
          <div class="descript_s"> 
            {{$t('About_Navbar.eve')}}
          </div>
          
          <div class="company_env_show">
            <div class="show_item">
              <div class="item_show_img">
                <img src="../../assets/images/aboutUs/env_one.jpg" />
              </div>
            </div>
             <div class="show_item">
              <div class="item_show_img">
                <img src="../../assets/images/aboutUs/env_two.jpg" />
              </div>
            </div> <div class="show_item">
              <div class="item_show_img">
                <img src="../../assets/images/aboutUs/env_three.jpg" />
              </div>
            </div> <div class="show_item">
              <div class="item_show_img">
                <img src="../../assets/images/aboutUs/env_four.jpg" />
              </div>
            </div>
          </div>
          
        </div>
      </div> -->

      
      <div class="honor_info"  v-if="active_menus=='honor'">
          <div class="honor_content">
              <div class="title">{{$t('NavabarText.navbr_child_about_2')}}</div>
              <div class="honor_detail">
                  <div class="honor_item_img">
                      <div class="img_sd">
                          <img src="../../assets/images/honor/honor_one.png" />
                      </div>
                  </div>
                  <div class="honor_process_content">
                      <div class="process_title">
                          <div class="title_name">{{$t('honor.start')}}</div>
                          <div class="title_date">(2014-2017)</div>
                      </div>
                      <div class="process_content">
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">{{$t('honor.item_1')}}</div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                 {{$t('honor.item_2')}}
                              </div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                 {{$t('honor.item_3')}}
                              </div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out cycle_out_active">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                 {{$t('honor.item_4')}}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

               <div class="honor_detail">
                  
                  <div class="honor_process_contents">
                      <div class="process_title">
                          <div class="title_name">{{$t('honor.end')}}</div>
                          <div class="title_date">(2018-2021)</div>
                      </div>
                      <div class="process_content">
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">{{$t('honor.item_5')}}</div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                  {{$t('honor.item_6')}}
                              </div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                 {{$t('honor.item_7')}}
                              </div>
                          </div>
                           <div class="process_item">
                              <div class="cycle_out cycle_out_active">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                  {{$t('honor.item_8')}}
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="honor_item_img">
                      <div class="img_sd">
                          <img src="../../assets/images/honor/honor_two.png" />
                      </div>
                  </div>
              </div>
          </div>

          
      </div>



      <div class="culture_info" v-if="active_menus=='culture'&&teamItemList.length>0">
          <div class="culture_content">
              <div class="title_s">{{$t('NavabarText.team_culture')}}</div>
              <div class="title_descript">{{$t('NavabarText.team_culture_desc')}}</div>
              <div class="culture_team">
                  <div class="team_content">
                      <div class="team_item" v-for="(item,index) in teamItemList" :key="item.id" :class="item.hidden==true?'team_item_hidden':''" @click="watchDetail(item)">
                          <div class="item_img">
                              <img :src="item.synopsisImg"/>
                          </div>
                          <div class="item_desc">{{item.articleAbstract}}</div>
                         <div class="item_detail">
                              <div class="detail_btn" @click="watchDetail(item)">查看详情</div>
                          </div>
                      </div>
                  </div>
                  <div class="arrow_left" id="left" @click="leftClick">
                     <span class="icon iconfont icon-zuojiantou1"></span>
                  </div>
                  <div class="arrow_right" id="right" @click="rightClick">
                     <span class="icon iconfont icon-iconfontjiantouyou"></span>
                  </div>
              </div>
          </div>
          
      </div>


      <div class="company_culture_info" :class="$store.state.lang=='en-US'?'eng_company_culture_info':''"  v-if="active_menus=='culture'">
          <div class="company_culture_content">
              <div class="company_culture_title">{{$t('NavabarText.navbr_child_about_3')}}</div>
              <!-- <div class="company_culture_desc">{{$t('NavabarText.company_culture_desc')}}</div> -->
              <div class="company_content_culture">
                    <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/aboutUs/company_h.png" />
                      </div>
                      <div class="item_titles">{{$t('NavabarText.company_culture_title')}}</div>
                      <div class="item_descs">{{$t('NavabarText.company_culture_desc')}}</div>
                  </div>
                  <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/aboutUs/1.jpg" />
                      </div>
                      <div class="item_titles">{{$t('corporate.item_1')}}</div>
                      <div class="item_descs">{{$t('corporate.item_1_desc')}}</div>
                  </div>
                  <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/aboutUs/2.jpg" />
                      </div>
                      <div class="item_titles">{{$t('corporate.item_2')}}</div>
                      <div class="item_descs">{{$t('corporate.item_2_desc')}}</div>
                  </div>
                  <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/aboutUs/3.jpg" />
                      </div>
                      <div class="item_titles">{{$t('corporate.item_3')}}</div>
                      <div class="item_descs">{{$t('corporate.item_3_desc')}}</div>
                  </div>
                  <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/aboutUs/4.jpg" />
                      </div>
                      <div class="item_titles">{{$t('corporate.item_4')}}</div>
                      <div class="item_descs">{{$t('corporate.item_4_desc')}}</div>
                  </div>
                
                  
              <!-- <div class="company_culture_desc">{{$t('NavabarText.company_culture_desc')}}</div> -->
              </div>
          </div>

          <div class="company_culture_content">
            <div class="company_culture_title">{{$t('NavabarText.navbr_child_about_5')}}</div>
            <div class="company_content_culture">
                  <div class="culture_item">
                    <div class="culture_item_img">
                        <img src="../../assets/images/aboutUs/company_culture.png" />
                    </div>
                    <!-- <div class="item_titles">{{$t('NavabarText.navbr_child_about_5')}}</div> -->
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_1')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_2')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_3')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_4')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_5')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_6')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_7')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_8')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_9')}}</div>
                    <div class="item_descs_s">{{$t('NavabarText.company_culture_desc_10')}}</div>
                </div>
               
              
                
            <!-- <div class="company_culture_desc">{{$t('NavabarText.company_culture_desc')}}</div> -->
            </div>
        </div>

      </div>

      <div class="develop_road" v-if="active_menus=='developRoad'">
            <!-- 时间线主体 -->
          <div class="timeline-container">
            <!-- 时间线 -->
            <div class="timeline-line"></div>

            <!-- 时间节点 -->
            <div 
              v-for="(item, index) in timelineData"
              :key="index"
              :class="['time-node', index % 2 === 0 ? 'left' : 'right']"
            >
              <!-- 年份标记 -->
              <div class="year-marker">
                <span class="year-text">{{ item.year }}</span>
              </div>

              <!-- 内容卡片 -->
              <el-card class="content-card" shadow="hover">
                <!-- <div class="card-media">
                  <img :src="item.image" :alt="item.year + '年大事记'" class="node-image">
                </div> -->
                <div class="card-body">
                  <div 
                    v-for="(event, eIndex) in item.events"
                    :key="eIndex"
                    class="event-item"
                  >
                    <!-- <div class="event-date">{{ event.date }}</div> -->
                    <div class="event-desc">{{ event.description }}</div>
                  </div>
                  <!-- <el-button type="success" class="more-btn">More</el-button> -->
                </div>
              </el-card>
            </div>
          </div>
      </div>

      <div class="left_menus">
        <div class="menus_contents">
          <div class="memus_item" :class="active_menus=='instruction'?'menus_active':''" @click="active_menus='instruction'">{{$t('NavabarText.navbr_child_about_1')}}</div>
          <!-- <div class="memus_item" :class="active_menus=='developRoad'?'menus_active':''" @click="active_menus='developRoad'">{{$t('NavabarText.navbr_child_about_4')}}</div> -->
          <!-- <div class="memus_item" :class="active_menus=='honor'?'menus_active':''" @click="active_menus='honor'">{{$t('NavabarText.navbr_child_about_2')}}</div> -->
          <div class="memus_item" :class="active_menus=='culture'?'menus_active':''" @click="active_menus='culture'">{{$t('NavabarText.navbr_child_about_3')}}</div>
        </div>
      </div>
    </div>
</template>

<script>
import SubBanner from "@/components/sub-banner";
import { concatMeta } from '@/config/metaJson.js'
import{getArticleByTypeList} from '../../service/service.js'
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-关于我們',
      metaName:'广州市熵达贸易有限公司-关于我們',
      metaContent:'广州市熵达贸易有限公司-关于我們',
      keyword:'广州市熵达贸易有限公司,',
      description:'广州市熵达贸易有限公司' ,   
      form: {
        code: '',
        name: '',
        phone: '',
        needContent:'',
      },
      team_item_left_index:0,
      team_item_right_index:2,
      verfyImg: process.env.BASE_URL + "customer/getVerifyCode",//图片验证码地址
      teamItemList:[],
      corporateCultureCode:'corporate_culture',
      corporateCultureId:0,
      corporateCultureData:'',
      active_menus:'instruction',
      evnItemList:[
        {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_one.jpg',hidden:false},
        {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_two.jpg',hidden:false},
        {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_three.jpg',hidden:false},
        {id:3,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_four.jpg',hidden:false},
        {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_five.jpg',hidden:true},
        {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_six.jpg',hidden:true},
        {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_seven.jpg',hidden:true},
        {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_eight.jpg',hidden:true},
        {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_nine.jpg',hidden:true},
        {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_ten.jpg',hidden:true},
        {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/env_elven.jpg',hidden:true},
      ],
      evnItemListPreview:[
      ],
      evnPersonItemList:[
        {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_one.jpg',hidden:false},
        {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_two.jpg',hidden:false},
        {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_three(1).jpg',hidden:false},
        // {id:3,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_four.jpg',hidden:false},
        {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_five.jpg',hidden:false},
        {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_six.jpg',hidden:false},
        {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_seven.jpg',hidden:false},
        {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_eight.jpg',hidden:false},
        {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_nine.jpg',hidden:false},
        {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_ten.jpg',hidden:false},
        {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_elevn.jpg',hidden:false},
        {id:11,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_twelve.jpg',hidden:false},
        {id:12,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_threeteen.jpg',hidden:false},
        {id:13,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_fourteen.jpg',hidden:false},
        {id:14,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_fiveteen.jpg',hidden:false},
        {id:15,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (1).jpg',hidden:false},
        {id:16,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (1).png',hidden:false},
        {id:17,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (2).jpg',hidden:false},
        {id:18,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (3).jpg',hidden:false},
        {id:19,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (4).jpg',hidden:false},
        {id:20,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (5).jpg',hidden:false},
        {id:21,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (6).jpg',hidden:false},
        {id:22,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (7).jpg',hidden:false},
        {id:23,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (8).JPG',hidden:false},
        {id:24,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (9).jpg',hidden:false},
        {id:25,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (10).jpg',hidden:false},
        {id:26,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/person_1 (11).jpg',hidden:false},
      ],
      
      evnPersonItemListPreview:[
      ],
      
      timelineData: [
        {
          year: 2024,
         // image: require('@/assets/2022-event.jpg'),
          events: [
            {
              date: '',
              description: '2024 年卡尔史托斯经销商第、期技术朋务培训'
            },
            {
              date: '',
              description: '协议经销商工程师技术服务认证培训'
            },
            {
              date: '',
              description: '校招实习生交流会'
            },
            {
              date: '',
              description: '荣获国控广州 2023年度(器械)潜力新锐奖'
            },
            {
              date: '',
              description: '8月8号思捷泰克手术直播会议'
            }
          ]
        },
        {
          year: 2023,
          //image: require('@/assets/2021-event.jpg'),
          events: [
            {
              date: '',
              description: '2023.4.14 大东社区公益活动'
            },
            {
              date: '',
              description: '2023.3.17 医孔智美·肠享未来南方医科大学南方医院两孔腹腔镜结直肠癌手术研过会'
            },
            {
              date: '',
              description: '2023.6.20 南方医院 消化内镜下纳米碳注射标记临床应用专家研过会'
            },
            {
              date: '',
              description: '2023.12.6 深圳招商会'
            },
          ]
        },
        {
          year: 2022,
          //image: require('@/assets/2021-event.jpg'),
          events: [
            {
              date: '',
              description: '2022年7月8日共建校企合作助力乡村振兴慰问物资捐赠暨校企合作座谈会(广东食品药品职业学院)'
            },
            {
              date: '',
              description: '2022年度广东省湖北商会优秀会员企业腹腔镜胃癌手术演示巡回直播活动--四省联动广东站'
            },
            {
              date: '',
              description: '2022.6.14访企拓岗促就业人才供需对接交流会(医疗器械)'
            },
          ]
        },
        {
          year: 2021,
          //image: require('@/assets/2021-event.jpg'),
          events: [
            {
              date: '',
              description: '2021.4.8 storz超高清影像系统产品知识培训'
            },
            {
              date: '',
              description: '2021.11.25 白云区委领导来公司视察'
            },
            {
              date: '',
              description: '2021.12.7 逸术胃道-第八届逸思“胃”道南方医院胃癌大师班'
            },
            {
              date: '',
              description: '2021.12.24 中山大学附属第一医院泌尿腔内镜手术技术培训班'
            },
          ]
        },
        {
          year: 2020,
          //image: require('@/assets/2021-event.jpg'),
          events: [
            {
              date: '',
              description: '2020年专利转化项目成立及调研'
            },
            {
              date: '',
              description: '2020.5.29 熵达首届师徒结业暨颁奖典礼'
            },
            {
              date: '',
              description: '获广东食品药品职业学院教学实习基地'
            },
            {
              date: '',
              description: '获2020年度广东省守合同重信用企业'
            },
            {
              date: '',
              description: '2020.5.30施爱德新品发布会'
            },
            {
              date: '',
              description: '2020.7.3南方单孔腹腔镜技术交流会(深圳站)'
            },
            {
              date: '',
              description: '2020.8.7单孔腹腔镜在妇科的应用沙龙会(广州站)'
            },
            {
              date: '',
              description: '2020.8.28南方单孔腹腔镜技术交流会(广州站)'
            },
          ]
        },
        {
          year: 2019,
          //image: require('@/assets/2021-event.jpg'),
          events: [
            {
              date: '',
              description: '2019.12.16 熵达第一届工会成立选举'
            },
            {
              date: '',
              description: '2019珠江国际泌尿外科高新技术论坛'
            },
            {
              date: '',
              description: '2019.3.22 starport 单孔产品交流会'
            },
            {
              date: '',
              description: '2019.8.14 中山六院单孔联盟会议'
            },
            {
              date: '',
              description: '2019.9.21南方医院CLAS年会'
            },
            {
              date: '',
              description: '2019.11.27施爱德新品发布会'
            },
            {
              date: '',
              description: '2019.7.4中山三院岭南分院科会'
            },
          ]
        },
        {
          year: 2018,
          //image: require('@/assets/2021-event.jpg'),
          events: [
            {
              date: '',
              description: '2018.9.20 中企信办信用建设工作委员会会员单位'
            },
            {
              date: '',
              description: '2018.12.8 中国管理科学研究院品牌推进委员会授予:《中国医疗行业质量可信企业》'
            },
            {
              date: '',
              description: '2018.12.8 中国管理科学研究院品牌推进委员会授予:《中国医疗行业具有投资价值企业》'
            },
            {
              date: '',
              description: '2018.12.14 微创外科会议'
            },
          ]
        },
         {
          year: 2017,
          //image: require('@/assets/2021-event.jpg'),
          events: [
            {
              date: '',
              description: 'CLASSIC会议'
            },
          ]
        }
      ]//.reverse() // 直接反转数组实现倒序
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    },
    'corporateCultureId':function(nval,oval){
      if(nval!=0){
        this.getArticleCorporateCultureByList(1,999);
      }
    },
  },
  methods: {
    
      watchDetail(item){
        this.$router.push({
            path: '/article?id='+item.id
        });
      },
      async getArticleCorporateCultureByList(pageNum,pageSize){
        let resp=await getArticleByTypeList(this.corporateCultureId,pageNum,pageSize);
        if(resp){
            if(resp.data){
                let i=0;
                resp.data.map((v)=>{
                    v.synopsisImg=process.env.BASE_IMG_URL+v.synopsisImg;
                    if(i<4){
                         v.hidden=false;
                    }else{
                        v.hidden=true;
                    }
                    i++;
                })
            }
            this.teamItemList=resp.data;
        }
      },
      getMaxIndex(){
          var maxIndex=0;
          for(var i=0;i<this.teamItemList.length-1;i++){
              if(this.teamItemList[i].hidden==false){
                  if(maxIndex<i){
                    maxIndex=i;
                  }
                  
              }
          }
          return maxIndex;
      },
      getMinIndex(){
        var minIndex=-1;
          for(var i=0;i<this.teamItemList.length-1;i++){
              if(this.teamItemList[i].hidden==false){
                 
                  if(minIndex==-1||minIndex>i){
                      minIndex=i;
                  }
              }
          }
          return minIndex;
      },
      //向左出栈
      leftClick(){
        let origTeamList=this.teamItemList;
        let objNewTeam=[];
        let first=origTeamList[0];
        for(var i=1;i<origTeamList.length;i++){
            objNewTeam.push(origTeamList[i]);
        }
        objNewTeam.push(first);
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.teamItemList=objNewTeam;
      },
      //向右出栈
      rightClick(){
        let origTeamList=this.teamItemList;
        let objNewTeam=[];
        let last=origTeamList[origTeamList.length-1];
        objNewTeam.push(last);
        for(var i=0;i<origTeamList.length-1;i++){
            objNewTeam.push(origTeamList[i]);
        }
        
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.teamItemList=objNewTeam;
      },

      leftPersonEnvClick(){
        let origTeamList=this.evnPersonItemList;
        let objNewTeam=[];
        let first=origTeamList[0];
        for(var i=1;i<origTeamList.length;i++){
            objNewTeam.push(origTeamList[i]);
        }
        objNewTeam.push(first);
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.evnPersonItemList=objNewTeam;
      },
      leftEnvClick(){
        let origTeamList=this.evnItemList;
        let objNewTeam=[];
        let first=origTeamList[0];
        for(var i=1;i<origTeamList.length;i++){
            objNewTeam.push(origTeamList[i]);
        }
        objNewTeam.push(first);
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.evnItemList=objNewTeam;
      },
      righPersontEnvClick(){
        let origTeamList=this.evnPersonItemList;
        let objNewTeam=[];
        let last=origTeamList[origTeamList.length-1];
        objNewTeam.push(last);
        for(var i=0;i<origTeamList.length-1;i++){
            objNewTeam.push(origTeamList[i]);
        }
        
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.evnPersonItemList=objNewTeam;
      },
      rightEnvClick(){
        let origTeamList=this.evnItemList;
        let objNewTeam=[];
        let last=origTeamList[origTeamList.length-1];
        objNewTeam.push(last);
        for(var i=0;i<origTeamList.length-1;i++){
            objNewTeam.push(origTeamList[i]);
        }
        
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.evnItemList=objNewTeam;
      },
      getEvnItemListPreview(){
        this.evnItemListPreview=[]
        this.evnItemList.map((v)=>{
          this.evnItemListPreview.push(v.synopsisImg)
        })
      },
      
      getPersonEvnItemListPreview(){
        this.evnPersonItemListPreview=[]
        this.evnPersonItemList.map((v)=>{
          this.evnPersonItemListPreview.push(v.synopsisImg)
        })
      }
  },
  
  created () {

    this.getPersonEvnItemListPreview()
      this.getEvnItemListPreview()
  },
   mounted() {
    if(this.$store.state.ArticleTypeData){
      let ArticleTypeData=this.$store.state.ArticleTypeData;
      ArticleTypeData.map((v)=>{
        if(v.code==this.corporateCultureCode){
          this.corporateCultureId=v.id
        }
      });
    }
    $(window).scroll(function () {
    console.log("$(window).scrollTop()",$(window).scrollTop())
    console.log('width',document.body.clientWidth)
    let width=document.body.clientWidth*1;
    if(width*1<900){
      $('.left_menus').addClass('left_menus_position_min');
    }else{
       $('.left_menus').removeClass('left_menus_position');
        $('.left_menus').removeClass('left_menus_position_max');
        $('.left_menus').removeClass('left_menus_position_min');
      if ($(window).scrollTop() >= 400) {
         if(width*1>1600){
          $('.left_menus').addClass('left_menus_position_max');
         }else if(width*1<900){
          $('.left_menus').addClass('left_menus_position_min');
         }else{
          $('.left_menus').addClass('left_menus_position');
         }
      }else{
        $('.left_menus').removeClass('left_menus_position');
        $('.left_menus').removeClass('left_menus_position_max');
        $('.left_menus').removeClass('left_menus_position_min');
      }
    }
    })
  },
}
</script>
<style lang='scss' scoped>
  .company_introduction{
      width:100%;
      background: url('~@/assets/images/aboutUs/background_one.png') no-repeat;
      background-size: 100% 100%;
      // height: 1034px;
      .company_introd_info{
        width:70%;
        margin:auto;
        
        .company_introd_detail{
          padding:102px 0px;
          .title{
            color:#4f7cbd;
            font-size: 40px;
            font-weight: bold;
            margin-bottom: 71px;
          }
          .detail_content{
            display: flex;
            align-items: center;
            justify-content: center;
            .item_c{
              padding-bottom:73px;
              padding-left:130px;
              .item_c_img{
                width: 580px;
                // height: 320px;
                img{
                  width:100%;
                  height: 100%;
                }
              }
              .item_c_text{
                text-align: left;
                width: 580px;
                .t_title{
                  font-size: 21px;
                  font-weight: bold;
                  color:#333333;
                  margin-bottom: 27px;
                }
                .t_content{
                  
                  font-size: 21px;

                  line-height: 40px;
                  color:#333333;

                }
              }
              
            }
          }
        }
      }
  }

  .company_environment{
    width:100%;
    background-color: #f8f8f8;
    .company_environment_content{
      width:70%;
      margin:auto;
      padding:120px 0px 40px 0px;
      .title{
        font-size: 40px;
        font-weight: bold;
        color:#4f7cbd;
        margin-bottom:38px;
      }
      .descript_s{
        font-size:18px;
        color:#333333;
        margin-bottom:110px;
      }
      .company_env_show{
        display: flex;
        justify-content: center;
        align-items: center;
        .show_item{
          padding-left:42px;
          padding-bottom:25px;
          .item_show_img{
          max-width:261px;
          img{
            width:100%;
            height: 100%;
          }
        }
        }
        
      }
    }
  }



  .honor_info{
    width:100%;
    background:#fff;
    .honor_content{
        width:70%;
        margin:auto;
        padding:100px 0px; 
        
      .title{
        font-size: 40px;
        font-weight: bold;
        color:#4f7cbd;
        margin-bottom:38px;
      }
        .honor_detail{
            display: flex;
            justify-content: space-between;
           align-items: center;
           margin-bottom:220px;
           margin-top:20px;
            .honor_item_img{
           margin-bottom:40px;
        //    margin-right:31px;
                .img_sd{
                  img{
                    width:100%;
                    height: auto;
                  }
                }
            }
          &:last-child{
            
           margin-bottom:0px !important;
          }
        }
    }
}

.honor_process_content{
    // width:70%;
    // width:773px;
    text-align: center;
    .process_title{
        display:flex;
        justify-content: center;
        align-items: center;
        .title_name{
            font-size:22px;
            color:#333;
            font-weight:bold;
        }
        .title_date{
            font-size: 16px;
            color:#666666;
        }

    }
    .process_content{
        width:100%;
        display:flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: row;
        margin-top:63px;
        overflow: hidden;
        .process_item{
           
            position: relative;
            display: flex;
            align-items: center;
            justify-content:center;
            flex-direction: column;
            
            width:230px;
            padding-left:70px;
            .cycle_out{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 23px;
                height: 23px;
                border: solid 1px #b5b5b5;
                border-radius: 50%;
              .cycle_in{
                width: 14px;
                height: 14px;
                background-color: #b5b5b5;
                border-radius: 50%;
              }   
            }
            .cycle_out_active{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 23px;
                height: 23px;
                border: solid 1px #4f7cbd;
                border-radius: 50%;
                z-index: 9;
              .cycle_in{
                width: 14px;
                height: 14px;
                background-color: #4f7cbd;
                border-radius: 50%;
              }   
            }
            // .cycle_out:after{
            //     content:" ";
            //     position:absolute;
            //     left:20px;
            //     top:10px;
            //     bottom:0;
            //     width:100%;
            //     height:2px;
            //     transform:scaleY(.5);
            //     background-color:#b5b5b5;
            // }
            
            .process_c_info{
                margin-top:40px;
                font-size: 14px;
                color:#000000;
                text-align: left;
            }
            // &:first-child{
            //     margin-left:31px  !important; 
            // }
        }
        .process_item:after{
                content:" ";
                position:absolute;
                left:60%;
                top:10px;
                bottom:0;
                width:100%;
                height:2px;
                transform:scaleY(.5);
                background-color:#b5b5b5;
        }
        .process_item:last-child:after{
                content:" ";
                position:absolute;
                left:20px;
                top:10px;
                bottom:0;
                width:0;
                height:0px;
                transform:scaleY(.5);
                background-color:red;
        }
        
    }
}

.honor_process_contents{
    // width:70%;
    // width:773px;
    text-align: center;
    
    margin-right:20px;
    .process_title{
        display:flex;
        justify-content: center;
        align-items: center;
        .title_name{
            font-size:22px;
            color:#333;
            font-weight:bold;
        }
        .title_date{
            font-size: 16px;
            color:#666666;
        }

    }
    .process_content{
        width:100%;
        display:flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: row;
        margin-top:63px;
        .process_item{
           
            position: relative;
            display: flex;
            align-items: center;
            justify-content:center;
            flex-direction: column;
            
            width:210px;
            padding-left:70px;
            .cycle_out{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 23px;
                height: 23px;
                border: solid 1px #b5b5b5;
                border-radius: 50%;
              .cycle_in{
                width: 14px;
                height: 14px;
                background-color: #b5b5b5;
                border-radius: 50%;
              }   
            }
            .cycle_out_active{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 23px;
                height: 23px;
                border: solid 1px #4f7cbd;
                border-radius: 50%;
                z-index: 9;
              .cycle_in{
                width: 14px;
                height: 14px;
                background-color: #4f7cbd;
                border-radius: 50%;
              }   
            }
            // .cycle_out:after{
            //     content:" ";
            //     position:absolute;
            //     left:20px;
            //     top:10px;
            //     bottom:0;
            //     width:100%;
            //     height:2px;
            //     transform:scaleY(.5);
            //     background-color:#b5b5b5;
            // }
            
            .process_c_info{
                margin-top:40px;
                font-size: 14px;
                color:#000000;
                text-align: left;
            }
            &:first-child{
                padding-left:31px  !important; 
            }
        }
        .process_item:after{
                content:" ";
                position:absolute;
                left:60%;
                top:10px;
                bottom:0;
                width:100%;
                height:2px;
                transform:scaleY(.5);
                background-color:#b5b5b5;
        }
        .process_item:last-child:after{
                content:" ";
                position:absolute;
                left:20px;
                top:10px;
                bottom:0;
                width:0;
                height:0px;
                transform:scaleY(.5);
                background-color:red;
        }
        
    }
}
.culture_info_back{
  background: #fff;
  .culture_content{
    width:70%;
    margin:auto;
    padding:100px 0px; 
    .title_s{
        color: #4f7cbd;
        font-size:40px;
        font-weight: bold;
        cursor: pointer;
    }
    .title_descript{
        margin-top:55px;
        color:#333333;
        font-size: 22px;
        cursor: pointer;
    }
    .culture_team{
        margin-top:83px;
        position: relative;
        .team_content{
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }
        .team_item{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-left:5px;
            // padding-bottom:25px;
            .item_img{
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .item_desc{
                width:310px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-top: 18px;
                font-size: 20px;
                color: #333333;
                cursor: pointer;
            }
            .item_detail{
                margin-top: 25px;
                width:100%;
                display: flex;
                justify-content: center;
                .detail_btn{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width:120px;
                    height: 43px;
                    border-radius: 22px;
                    border: solid 1px #4f7cbd;
                    color:#4f7cbd;
                    cursor: pointer;
                }
                .item_detail_active{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width:120px;
                    height: 43px;
                    border-radius: 22px;
                    border: solid 1px #4f7cbd;
                    background-color: #4f7cbd;
                    color:#fff;
                }
                
                .detail_btn:hover{
                    border: solid 1px #4f7cbd !important;
                    background-color: #4f7cbd !important;
                    color:#fff !important;
                }
            }
            &:first-child{
                padding-left: 0px !important;
            }
        }
        
        .env_item{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-left:5px;
          // padding-bottom:25px;
         // height: 3rem;
          .env_item_img{
             height: 3rem;
             width:6.2rem;

              img{
                  width: 100%;
                  height: 100%;
              }
          }
      }
        .team_item_hidden{
            display:none;
        }

        .arrow_left{
            position: absolute;
            background-color: #4f7cbd;
          opacity: 0.5;
            color:#fff;
            font-size:30px;
            font-weight: bold;
            border-radius: 50%;
            width: 42px;
            height: 42px;
            top:35%;
            left:-8%;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
                font-size:22px;
            }
        }
        .arrow_right{
            position: absolute; 
            background-color: #4f7cbd;
          opacity: 0.5;
            color:#fff;
            font-size:30px;
            font-weight: bold;
            border-radius: 50%;
            top:35%;
            right:-8%;
            cursor: pointer;
            width: 42px;
            height: 42px;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
                font-size:22px;
            }
        }
        .arrow_left:hover{
            width: 48px;
            height: 48px;
            opacity: 0.8;
            
        }
        .arrow_right:hover{
            width: 48px;
            height: 48px;
            opacity: 0.8;

        }

    }
}
}

.culture_info{
    width:100%;
    background:#f8f8f8;
    .culture_content{
        width:70%;
        margin:auto;
        padding:100px 0px; 
        .title_s{
            color: #4f7cbd;
            font-size:40px;
            font-weight: bold;
            cursor: pointer;
        }
        .title_descript{
            margin-top:55px;
            color:#333333;
            font-size: 22px;
            cursor: pointer;
        }
        .culture_team{
            margin-top:83px;
            position: relative;
            .team_content{
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
            }
            .team_item{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding-left:5px;
                // padding-bottom:25px;
                .item_img{
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .item_desc{
                    width:310px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-top: 18px;
                    font-size: 20px;
                    color: #333333;
                    cursor: pointer;
                }
                .item_detail{
                    margin-top: 25px;
                    width:100%;
                    display: flex;
                    justify-content: center;
                    .detail_btn{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width:120px;
                        height: 43px;
                        border-radius: 22px;
                        border: solid 1px #4f7cbd;
                        color:#4f7cbd;
                        cursor: pointer;
                    }
                    .item_detail_active{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width:120px;
                        height: 43px;
                        border-radius: 22px;
                        border: solid 1px #4f7cbd;
                        background-color: #4f7cbd;
                        color:#fff;
                    }
                    
                    .detail_btn:hover{
                        border: solid 1px #4f7cbd !important;
                        background-color: #4f7cbd !important;
                        color:#fff !important;
                    }
                }
                &:first-child{
                    padding-left: 0px !important;
                }
            }
            
            .env_item{
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding-left:5px;
              // padding-bottom:25px;
             // height: 3rem;
              .env_item_img{
                 height: 3rem;
                 width:6.2rem;

                  img{
                      width: 100%;
                      height: 100%;
                  }
              }
          }
            .team_item_hidden{
                display:none;
            }

            .arrow_left{
                position: absolute;
                background-color: #4f7cbd;
	            opacity: 0.5;
                color:#fff;
                font-size:30px;
                font-weight: bold;
                border-radius: 50%;
                width: 42px;
                height: 42px;
                top:35%;
                left:-8%;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                span{
                    font-size:22px;
                }
            }
            .arrow_right{
                position: absolute; 
                background-color: #4f7cbd;
	            opacity: 0.5;
                color:#fff;
                font-size:30px;
                font-weight: bold;
                border-radius: 50%;
                top:35%;
                right:-8%;
                cursor: pointer;
                width: 42px;
                height: 42px;
                display: flex;
                justify-content: center;
                align-items: center;
                span{
                    font-size:22px;
                }
            }
            .arrow_left:hover{
                width: 48px;
                height: 48px;
                opacity: 0.8;
                
            }
            .arrow_right:hover{
                width: 48px;
                height: 48px;
                opacity: 0.8;

            }

        }
    }
}


.company_culture_info{
    width:100%;
    background: url('~@/assets/images/corporateCulture/background_one.png') no-repeat;
    background-size: 100% 100%;
    
    .company_culture_content{
        width:70%;
        margin:auto;
        padding:87px 0px 196px 0px; 
        .company_culture_title{
            font-size: 40px;
            font-weight: bold;
            color: #ffffff;
        }
        .company_culture_desc{
            margin-top:60px;
            font-size: 23px;
            font-weight: bold;
            color: #ffffff;
        }
        .company_content_culture{
            margin-top:100px;
            display: flex;
            justify-content: center;
            align-items: center;
            .culture_item{
                background-color: #ffffff;
                margin-left:11px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                //  height: 445px;
                // width:292px;
                padding:15px 15px 37px 15px;
                .culture_item_img{
                    img{
                        width:100%;
                        height: 100%;
                    }
                }
                .item_titles{
                    font-size: 24px;
                    font-weight: bold;
                    color:#333333;
                    margin-top:25px;
                    margin-bottom: 23px;
                }
                .item_descs{
                    position: relative;
                    text-align: left;
                    min-width: 213px;
                    font-size: 20px;
                    height: 30px;

                    color:#999999;
                }
                .item_descs:before{
                    content:" ";
                    position:absolute;
                    left:0;
                    top:-10px;
                    width:100%;
                    height:1px;
                    transform:scaleY(.5);
                    background-color:#eeeeee;
                }
                
                .item_descs_s{
                  position: relative;
                  text-align: left;
                  min-width: 213px;
                  font-size: 20px;
                  height: 30px;
                  font-size: 24px;
                  font-weight: bold;
                  color:#333333;
                  margin-top:25px;
                  margin-bottom: 2px;
                  margin-left:50px;
              }
              .item_descs_s::before {
                content: "·"; /* 圆点字符 */
                position: absolute;
                left: -25px; /* 调整圆点位置 */
                top: -18px;
                font-size: 48px; /* 比文本稍大的圆点 */
                color: #000; /* 蓝色圆点 */
                font-weight: bold;
            }
            }
        }
    }
}

.eng_company_culture_info{
  
            .culture_item{
              background-color: #ffffff;
              margin-left:11px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-direction: column;
              padding:15px 15px 37px 15px;
                .culture_item_img{
                    img{
                        width:100%;
                        height: 100%;
                    }
                }
                .item_titles{
                    font-size: 24px;
                    font-weight: bold;
                    color:#333333;
                    margin-top:25px;
                    margin-bottom: 23px;
                }
                .item_descs{
                    position: relative;
                    text-align: left;
                    min-width: 213px;
                    font-size: 21px;
                    height: 30px;
                    color:#999999;
                }
                .item_descs:before{
                    content:" ";
                    position:absolute;
                    left:0;
                    top:-10px;
                    width:100%;
                    height:1px;
                    transform:scaleY(.5);
                    background-color:#eeeeee;
                }
                  
                .item_descs_s{
                  position: relative;
                  text-align: left;
                  min-width: 213px;
                  font-size: 20px;
                  height: 30px;
                  font-size: 24px;
                  font-weight: bold;
                  color:#333333;
                  margin-top:25px;
                  margin-bottom: 2px;
                  margin-left:50px;
              }
              .item_descs_s::before {
                content: "·"; /* 圆点字符 */
                position: absolute;
                left: -25px; /* 调整圆点位置 */
                top: -18px;
                font-size: 48px; /* 比文本稍大的圆点 */
                color: #000; /* 蓝色圆点 */
                font-weight: bold;
            }
            }
     
}

.left_menus_position{
   top:25% !important;
   opacity: 1 !important;
}
.left_menus_position_max{
   top:35% !important;
   opacity: 1 !important;
   left:2% !important;
}
.left_menus_position_min{
   top:28% !important;
   opacity: 1 !important;
   left:0% !important;
}
.left_menus{
  position: fixed;
  left:3%;
  top:65%;
  opacity: 0;
  border-radius: 5px;
  color:#333333;
  font-size: 18px;
  width:192px;
  .menus_contents{
   font-size:20px;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   .memus_item{
     padding-top:7px;
     padding-bottom: 7px;
     width: 100%;
     cursor:pointer;
    //  &:last-child{
    //    padding-bottom: 0px !important;
    //  }
   }
   .memus_item:hover{
     background:linear-gradient(left,#4f7cbd,#f3f4f7) !important;
     color:#ffffff !important;
     font-weight: bold !important;
   }
   .menus_active{
     
     background:linear-gradient(left,#4f7cbd,#f3f4f7) !important;
     color:#ffffff !important;
     font-weight: bold !important;
   }
   
  }
}


/* 标题样式 */
.header-section {
  text-align: center;
  margin-bottom: 60px;
  .title-cn {
    color: #4CAF50;
    font-size: 36px;
    margin-bottom: 12px;
  }
  .title-en {
    color: #666;
    font-size: 18px;
    font-weight: normal;
  }
}

.develop_road{
  min-height: 500px;
}

/* 时间轴容器滚动处理 */
.scroll-wrapper {
  height: 100vh;
  overflow: auto;
  -ms-overflow-style: none;       /* IE/Edge */
}

.scroll-wrapper::-webkit-scrollbar {
  width: 0 !important;            /* Chrome/Safari */
}
/* 时间线容器 */
.timeline-container {
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 0 40px 0;
  height: 100%;
  margin-bottom: 30px;
}

/* 中央时间线 */
.timeline-line {
  position: absolute;
  left: 50%;
  width: 4px;
  background: #89cbe9;
  top: 50px;
  bottom: 0;
  transform: translateX(-50%);
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: -8px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #009fe9;
  }
}

/* 时间节点通用样式 */
.time-node {
  position: relative;
  width: 50%;
  padding: 30px 40px;
  min-height: 300px;

  /* 年份标记 */
  .year-marker {
    position: absolute;
    top: 30px;
    width: 80px;
    height: 80px;
    border: 3px solid #009fe9;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    .year-text {
      color: #009fe9;
      font-size: 24px;
      font-weight: bold;
    }
  }
}

/* 左侧节点 */
.time-node.left {
  margin-right: 50%;
  .year-marker {
    right: -40px;
  }
  .content-card {
    margin-right: 80px;
  }
}

/* 右侧节点 */
.time-node.right {
  margin-left: 50%;
  .year-marker {
    left: -40px;
  }
  .content-card {
    margin-left: 80px;
  }
}

/* 内容卡片 */
.content-card {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  ::v-deep .el-card__body {
    padding: 0;
  }
  
  .card-media {
    height: 220px;
    overflow: hidden;
    .node-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s;
    }
  }
  
  .card-body {
    padding: 20px;
    .event-item {
      text-align: left;
      margin-bottom: 15px;
      font-size: 18px;
      .event-date {
        color:#009fe9 ;// #4CAF50;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .event-desc {
        position: relative;
        color: #666;
        line-height: 1.8;
        position: relative;
        padding-left: 28px;
        font-size: 21px;
      }
      .event-desc::before {
        content: "·";
        position: absolute;
        left: 0;
        color: #009fe9;
        font-weight: bold;
        top:-20px;
        font-size: 40px;
      }
    }
    .more-btn {
      margin-top: 20px;
      background: #009fe9;
      border-color: #009fe9;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}

/* 响应式处理 */
@media (max-width: 768px) {
  .timeline-line {
    left: 40px;
  }
  
  .time-node {
    width: 100% !important;
    padding-left: 80px !important;
    padding-right: 20px !important;
    margin: 0 !important;
    
    .year-marker {
      left: 0 !important;
      right: auto !important;
      width: 60px;
      height: 60px;
      .year-text {
        font-size: 20px;
      }
    }
    
    .content-card {
      margin: 0 !important;
    }
  }
}


/* 左侧卡片箭头 */
.time-node.left .content-card::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -22px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 20px solid white; /* 箭头颜色与卡片背景一致 */
  z-index: 1;
}

.time-node.left .content-card::before {
  content: '';
  position: absolute;
  top: 50%;
  right: -24px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 16px solid transparent;
  border-bottom: 16px solid transparent;
  border-left: 22px solid #009fe9; /* 外边框颜色 */
  z-index: 0;
}

/* 右侧卡片箭头 */
.time-node.right .content-card::after {
  content: '';
  position: absolute;
  top: 50%;
  left: -22px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 20px solid white; /* 箭头颜色与卡片背景一致 */
  z-index: 1;
}

.time-node.right .content-card::before {
  content: '';
  position: absolute;
  top: 50%;
  left: -24px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 16px solid transparent;
  border-bottom: 16px solid transparent;
  border-right: 22px solid #009fe9; /* 外边框颜色 */
  z-index: 0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .time-node .content-card::before,
  .time-node .content-card::after {
    display: none; /* 移动端隐藏箭头 */
  }
}
</style>
<style>
.el-card {
  border: 0.013333rem solid #009fe9 !important;
  box-shadow: 0 2px 12px 0 rgba(0, 159, 233, 0.2) !important;
}
</style>


// WEBPACK FOOTER //
// src/view/aboutUs/index.vue